import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const complaintCategoryService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/complaint-category/paginate', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
    const response = await axiosInstance.get('/complaint-category/' + id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/complaint-category', data)
    return response.data
  },
  update: async (data) => {
    const response = await axiosInstance.put(`/complaint-category/${data.id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/complaint-category/${id}`)
    return response.data
  },
}